export const sxStyled = theme => ({
  paper: {
    padding: {
      xs: theme.spacing(1.25),
      sm: theme.spacing(2.5),
    },
    minWidth: {
      xs: '70%',
      sm: '35%',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },

  title: {
    fontSize: {
      xs: '16px',
      sm: '24px',
    },
    fontWeight: {
      xs: 600,
      sm: 700,
    },
    textAlign: 'center',
    color: 'black',
  },

  subtitle: {
    fontSize: {
      xs: '12px',
      sm: '20px',
    },
    textAlign: 'center',
    marginTop: 0,
    marginBottom: {
      xs: 0,
      sm: theme.spacing(1.25),
    },
  },

  button: {
    fontSize: '18px',
    fontWeight: {
      xs: 600,
      sm: 700,
    },
    padding: {
      xs: '8px 16px',
      sm: '10px 20px',
    },
  },

  actions: {
    justifyContent: 'center',
  },
});
